<template>
  <div
    class="product-modal"
    :class="[{ isMobile: $store.getters['isMobile'] }]"
  >
    <v-btn
      @click="$emit('closeModel')"
      class="close-icon"
      size="large"
      icon="mdi-close"
      elevation="0"
    />
    <Breadcrumb
      v-if="breadcrumbItems.length"
      :items="breadcrumbItems"
      class="modal-breadcrumb"
    />
    <div class="product-modal-content d-flex">
      <div class="image-container">
        <img
          v-if="!productImages.length"
          :src="imageResize(product?.image)"
          :alt="product?.sku"
          class="product-image"
        />
        <ProductsGallery
          v-if="productImages.length"
          :mainImage="0"
          :images="productImages.map((img) => imageResize(img))"
        />
      </div>
      <div class="details">
        <div class="details-content">
          <div class="details-line">
            <span
              class="stock-label"
              :class="{
                'out-of-stock': !product?.AvailableInStock,
              }"
            >
              {{
                product?.AvailableInStock
                  ? $t("Products.productItem.AvailableInStock")
                  : $t("Products.productItem.outOfStock")
              }}
            </span>
            <span v-if="product?.discountPercent" class="discount-percent">
              {{ product?.discountPercent }}%
              {{ $t("Products.productItem.discount") }}</span
            >
          </div>
          <div
            v-if="product.PartTags && product.PartTags.length"
            class="part-tags"
          >
            <v-chip
              v-for="tag in product.PartTags"
              :key="tag.id"
              class="tag-chip"
              color="grey-lighten-3"
              variant="outlined"
            >
              <span class="tag-name">{{ tag.name }}</span>
              <span class="tag-divider">:</span>
              <span class="tag-value">{{ tag.value }}</span>
            </v-chip>
          </div>
          <div class="details-line">
            <h1>{{ product?.name }}</h1>
            <Prices
              :discountPercent="product?.discountPercent"
              :discountPrice="product?.discountPrice"
              :originPrice="product?.originPrice"
            />
          </div>
          <div class="details-line">
            <ProductDetailItem
              :value="product?.description"
              class="description"
            />
          </div>
        </div>
        <div class="divider" />
        <div class="mt-4">
          <!-- <span> {{ $t("Products.productItem.sku") }} </span> -->
          <v-label> {{ product?.sku }} </v-label>
        </div>
        <div class="quantity-wrapper">
          <QuantityButtons
            v-if="
              (product.isFromPriceList && isAuthenticated) ||
              !isAuthenticated ||
              priceListId === 'empty'
            "
            :packageQuant="product.package"
            :TheCounter="product.quant"
            @updateCounter="updateProduct"
            :disabled="isQuantityBtnDisable"
          />

          <div v-else>
            <span>
              <v-icon
                :size="'15px'"
                :color="'#FDC70F'"
                :icon="'mdi-information-box'"
              />
              מוצר לא במגוון
            </span>
          </div>
          <div
            v-if="product.quant > 0 || quantity > 0"
            class="package-info d-flex ga-1 align-self-lg-center"
          >
            <span>{{ product.package }}</span>
            <span v-if="product.package">במארז</span>
          </div>
        </div>
        <!-- <v-btn
          v-if="$route.params.rootCategory && $route.params.subCategory"
          class="more-details-btn mt-4"
          color="primary"
          variant="outlined"
          @click="navigateToFullProduct"
          prepend-icon="mdi-open-in-new"
        >
          {{ $t("ProductModal.moreDetails") || "פרטים נוספים" }}
        </v-btn> -->
      </div>
    </div>
    <div
      class="related-products-box"
      v-if="realatedProducts.length && quantity"
    >
      <h2>{{ $t("ProductModal.realatedProducts") }}</h2>
      <ProductsCarousel
        :products="realatedProducts"
        @updateProduct="updateCarousleProduct"
        :breakpoints="breakpoints"
      />
    </div>
  </div>
</template>

<script>
import Prices from "../../helpers/Prices.vue";
import ProductDetailItem from "../../helpers/ProductDetailItem.vue";
import QuantityButtons from "../../helpers/QuantityButtons.vue";
import ProductsCarousel from "../../helpers/homePage/ProductsCarousel.vue";
import ProductsGallery from "../../helpers/ProductsGallery.vue";
import Breadcrumb from "../Breadcrumb.vue";

export default {
  emits: ["updateProduct"],
  name: "ProductModal",
  components: {
    Prices,
    ProductDetailItem,
    QuantityButtons,
    ProductsGallery,
    ProductsCarousel,
    Breadcrumb,
  },
  data() {
    return {
      quantity: 0,
      realatedProducts: [],
      breakpoints: {
        200: {
          itemsToShow: 1,
          snapAlign: "start",
        },
        768: {
          itemsToShow: 1,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1600: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    };
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
    },
    priceListId: {
      type: String,
    },
  },
  created() {
    this.fetchRelatedProducts();
  },
  mounted() {
    this.setQuantityFromProduct();
  },
  methods: {
    imageResize(image) {
      const reSizeImage = image.replace("images", "imageResize");
      return reSizeImage + "?width=500";
    },
    setQuantityFromProduct() {
      if (this.product.quant) {
        this.quantity = this.product.quant;
      }
    },
    async fetchRelatedProducts() {
      try {
        const realatedProductsRes = await this.$store.dispatch(
          "Parts/fetchRelatedProducts",
          { familycode: this.product.familycode, part: this.product.part },
        );
        this.realatedProducts = await this.$store.dispatch(
          "Orders/updateQuantOfPartByCart",
          { products: realatedProductsRes.data, modifyParts: false },
        );
      } catch (err) {
        console.error(err);
      }
    },
    tofix(number, fix) {
      return Number(number)?.toFixed(fix);
    },
    updateProduct(quantity) {
      this.quantity = quantity;
      this.$emit("updateProduct", {
        product: this.product,
        quantity,
      });
    },
    updateCarousleProduct(updObj) {
      this.$emit("updateProduct", {
        ...updObj,
      });
    },
    // navigateToFullProduct() {
    //   // Build the full product page URL with category path
    //   const currentRootCategory = this.$route.params?.rootCategory;
    //   const currentSubCategory = this.$route.params?.subCategory;

    //   // If we're on a specific route with categories, use that
    //   if (currentRootCategory && currentRootCategory !== "products") {
    //     const params = {
    //       rootCategory: currentRootCategory,
    //       productId: this.product.part,
    //     };

    //     // Only add subcategory if it exists
    //     if (currentSubCategory) {
    //       params.subCategory = currentSubCategory;
    //     }

    //     // Build query without productid
    //     const query = { ...this.$route.query };
    //     delete query.productid;
    //     delete query.productId;

    //     this.$router.push({
    //       name: "CategoryProducts",
    //       params,
    //       query,
    //     });
    //   }
    //   // If we're on /products or no category, try to use the product's category info
    //   else if (this.product.Category?.RootCategory?.slug) {
    //     const params = {
    //       rootCategory: this.product.Category.RootCategory.slug,
    //       productId: this.product.part,
    //     };

    //     // Only add subcategory if it exists
    //     if (this.product.Category?.slug) {
    //       params.subCategory = this.product.Category.slug;
    //     }

    //     // Build query without productid
    //     const query = { ...this.$route.query };
    //     delete query.productid;
    //     delete query.productId;

    //     this.$router.push({
    //       name: "CategoryProducts",
    //       params,
    //       query,
    //     });
    //   }
    // },
  },
  computed: {
    breadcrumbItems() {
      const items = [];

      // Get category info from product
      if (this.product?.Category) {
        const category = this.product.Category;

        // Get root category from URL params
        const rootSlug = this.$route.params?.rootCategory;

        if (category.RootCategory) {
          const rootCategory = category.RootCategory;
          items.push({
            label: rootCategory.rootCategoryName,
            to: `/${rootCategory.slug}`,
          });
        } else if (rootSlug) {
          // Fallback to URL if RootCategory not available
          const rootCategory = this.$store.getters[
            "Category/getRootCategories"
          ].find((rc) => rc.path === rootSlug);
          if (rootCategory) {
            items.push({
              label: rootCategory.title,
              to: `/${rootSlug}`,
            });
          }
        }

        // Add the category (subcategory)
        items.push({
          label: category.categoryName,
          to: `/${rootSlug || category.RootCategory?.slug}/${category.slug}`,
        });

        // Add the product name as the last item (no link)
        items.push({
          label: this.product.name,
        });
      }

      return items;
    },
    productImages() {
      if (!this.product) return [];

      const images = [];
      // Add main product image first if it exists
      if (this.product.image) {
        images.push(this.product.image);
      }

      // Add images from PartImages array
      if (this.product.PartImages && this.product.PartImages.length > 0) {
        const partImages = this.product.PartImages.map((img) => img.image);
        images.push(...partImages);
      }

      return images;
    },
  },
};
</script>

<style lang="scss">
h2 {
  color: $appBlack;
}
@media (max-width: 601px) {
  .product-modal {
    .gallery {
      .v-window.v-carousel {
        height: 330px !important;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .v-overlay__content:has(.product-modal) {
    max-width: calc(100% - 20px) !important;
  }
  .product-modal-content {
    margin-top: 60px !important;
    flex-direction: column !important;
  }
  .product-modal {
    height: unset !important;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    width: 100%;
    padding: 10px !important;
    .close-icon {
      top: unset !important;
    }
  }
  .image-container {
    flex-basis: unset !important;
    width: 100% !important;
  }

  .details {
    flex-basis: unset !important;
    width: 100% !important;
  }
}
</style>

<style scoped lang="scss">
.modal-breadcrumb {
  margin-top: 20px;
  margin-bottom: 10px;
}

.package-info {
  font-size: 14px;
  color: #afafaf;
}
.quantity-wrapper {
  max-width: 134px;
  display: flex;
  flex-direction: column;
}

.more-details-btn {
  width: 100%;
  max-width: 150px;
  font-weight: 500;
}

.product-modal {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.product-modal-content {
  display: flex;
  margin-top: 100px;
  gap: 30px;
  flex-direction: row;
}

.image-container {
  flex-basis: 40%;
  width: 40%;
  position: relative;
}

.close-icon {
  z-index: 100;
  top: 20px;
  right: 20px;
  position: absolute;
}

.stock-label {
  display: inline-block;
  padding: 3px 20px 3px 10px;
  width: fit-content;
  background: #e6f6ef;
  color: #36b079;
  position: relative;
  margin-bottom: 20px;

  &::before {
    content: "";
    height: 6px;
    width: 6px;
    position: absolute;
    top: 50%;
    background-color: #36b079;
    right: 9px;
    transform: translateY(-50%);
    border-radius: 50%;
  }

  &.out-of-stock {
    color: #d13257;
    background: #f2e3e7;

    &::before {
      background-color: #d13257;
    }
  }
}

.product-image {
  width: 400px;
  height: 400px;
  object-fit: contain;
  border-radius: 10px;
}

.details {
  flex-basis: 65%;
  width: 300px;
}

.details-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.details-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.discount-percent {
  background: #bd94781f;
  color: $primaryColor;
  font-size: 16px;
  font-weight: 400;
  padding: 1px 5px;
  height: fit-content;
}
.divider {
  width: 100%;
  border-top: 2px dashed rgba(212, 212, 212, 0.39);
}

h1 {
  font-size: 25px;
  font-weight: 500;
}

.description {
  line-height: 21px;
}

.isTablet,
.isMobile {
  .product-modal {
    flex-direction: column;
  }

  // .image-container {
  //   width: 100%;
  //   flex-basis: auto;
  //   display: flex;
  //   flex-direction: row-reverse;
  //   align-items: center;
  // }

  .product-image {
    width: 220px;
    height: auto;
  }

  // .related-products-box {
  //   margin-bottom: 50px;
  // }
  .details {
    flex-basis: auto;
    width: 100%;
    margin-bottom: 20px;
  }

  .details-grid {
    grid-template-columns: 2fr 1fr;
  }

  .description,
  .prices {
    grid-column: 1 / -1;
  }
}

.part-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .tag-chip {
    border-radius: 16px;

    .tag-name {
      font-weight: 600;
      color: #333;
    }

    .tag-divider {
      margin: 0 4px;
      color: #666;
    }

    .tag-value {
      color: #666;
    }
  }
}
</style>
